module.exports = __webpack_public_path__ + "img/default_logo.45a36d19.png";